export class Reservation {
    id: number;
    persons: number;
    date: number;
    time: string;
    name: string;
    email: string;
    phone: any;
    message: string;
    code: string;
    reservationData: any;
    reservationId: string;
    reservation_code: number;
    reservation_status: number;
    payment_url: string;
    checkbox_privacy: boolean;
    checkbox_terms: boolean;
    department: {
      id: number;
      address: string;
      name: string;
      message: string;
      autoconfirmation: number;
      phone: string;
      order_pyszne_url: string;
      order_pizzaportal_url: string;
      order_ubereats_url: string;
      order_glovo_url: string;
      order_wolt_url: string;
      order_site_url: string;
      payment_required: boolean;
      payment_val: number;
      payment_total: number;
      halls: any[];
      hall_required: number;
      // order_bolt_url: string;
    };
    language: string;
    duration_id: number;
    preferred_hall_id: number;
    rwg_token: string;
    is_google: boolean;
    sellway_token: string;
    source: string;
    agreement: boolean;
    privacy_agreement: boolean;
    marketing_consent: boolean;
    price: number;
    is_queued: number;
    dining_option_id: number;
    guest_selections: any[];
}
